import { Role } from '@digitale-verhuurders-verklaring/core/src/models/functions/authentication/types';
import type { Directive, DirectiveBinding } from 'vue';

import { authUserHasAnyRole } from '../utils/auth';

export const vRole: Directive<HTMLElement, Role[]> = {
  async mounted(
    el: HTMLElement,
    binding: DirectiveBinding<Role[], string, string>,
  ) {
    if (!(await authUserHasAnyRole(binding.value))) {
      el.parentNode?.removeChild(el);
    }
  },

  async updated(
    el: HTMLElement,
    binding: DirectiveBinding<Role[], string, string>,
  ) {
    if (!(await authUserHasAnyRole(binding.value))) {
      el.parentNode?.removeChild(el);
    }
  },
};
